<template>
  <v-layout v-if="isLoggedIn">
    <v-container fluid grid-list-lg v-if="checkAccess()">
      <v-layout text-xs-center text-md-center mb-4>
        <v-flex xs1 sm1 md2 lg3></v-flex>
        <v-flex xs10 sm12 md8 lg6>
          <h1>Welcome to DataDash Admin Panel</h1>
          <!-- <pre>{{ indexData.applica[0] }}</pre> -->
        </v-flex>
        <v-flex xs1 sm1 md2 lg3></v-flex>
      </v-layout>
      <v-layout row wrap mb-2 v-if="getClientId()==1">
        <DynamicBlock />
      </v-layout>
      <v-layout row wrap mb-2 v-if="getClientId()==1">
        <v-flex md6>
          <EarnVsWithdraw />
        </v-flex>
        <v-flex md6>
          <RegistrationVsActive />
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-2 v-if="getClientId()==1">
        <v-flex md4>
          <ProjectBudget />
        </v-flex>
        <v-flex md4>
          <DasherDivision />
        </v-flex>
        <v-flex md4>
          <DasherAge />
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-2 v-if="getClientId()==1">
        <v-flex md4>
          <DasherIncome />
        </v-flex>
        <v-flex md4>
          <EducationQualification />
        </v-flex>
        <v-flex md4>
          <DasherRanks />
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-2 v-if="getClientId()==1">
        <v-flex md6>
          <Top10ProjectByRank />
        </v-flex>
        <v-flex md6>
          <v-layout row wrap mb-2>
            <v-flex md12>
              <DasherGender />
            </v-flex>
          </v-layout>
          <v-layout row wrap mb-2>
            <v-flex md12>
              <ResponseTracker />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
  <v-layout v-else>
    <HowItWorks class="mt-1"></HowItWorks>
  </v-layout>
</template>
<script>
  import { mapGetters } from "vuex";
  import HowItWorks from "../HowItWorks";
  import RegistrationVsActive from "./RegistrationVsActive";
  import DashersCoinVsWithdrawn from "./DashersCoinVsWithdrawn.vue";
  import ResponseTracker from "./ResponseTracker.vue";
  //pie chart
  import ProjectBudget from "./ProjectBudget";
  import DasherDivision from "./DasherDivision";
  import DasherAge from "./DasherAge";
  import DasherIncome from "./DasherIncome";
  import EducationQualification from "./EducationQualification";
  import DasherRanks from "./DasherRanks";
  import DasherGender from "./DasherGender";
  //dynamic block
  import DynamicBlock from "./DynamicBlock";
  //data table
  import Top10ProjectByRank from "./Top10ProjectByRank";
  import router from "../../router";

  export default {
    components: {
      HowItWorks,
      ProjectBudget,
      DasherDivision,
      DasherAge,
      DasherGender,
      RegistrationVsActive,
      EarnVsWithdraw: DashersCoinVsWithdrawn,
      DasherIncome,
      EducationQualification,
      DasherRanks,
      DynamicBlock,
      Top10ProjectByRank,
      ResponseTracker,
    },

    data: () => ({}),

    computed: {
      ...mapGetters(["isLoggedIn","subscriptionData"]),
    },
    methods:{
      getClientId(){
        if(this.subscriptionData.subscriptionPlan){
          return this.subscriptionData.subscriptionPlan.client_id;
        }
        return 0;
      },
      checkAccess(){
        let client_id = parseInt(localStorage.getItem("client_id"));
        if(client_id !=1){
          router.push("/project-list/");
        }
        return client_id == 1 ? true : false;
      },
    },
  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
    z-index: -1;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
  .scrollable {
    height: auto; /* or any height you want */
    overflow-y: auto;
  }
</style>
